import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Nav from "./Components/Nav.jsx";
import LoadingScreen from "./Components/Load.jsx"; 
import AboutUs from "./Components/AboutUs.jsx";
import ContactUs from "./Components/ContactUs.jsx";
import CompletedProject from "./Components/CompletedProject.jsx";
import Blogs from "./Components/Blogs.jsx";
import Services from "./Components/Services.jsx";
import ServiceDetail from "./Components/ServiceDetail.jsx"
import Footer from "./Components/Footer.jsx";
import WhatsAppButton from "./Components/WhatsAppButton.jsx";
import Home from "./Components/Home.jsx";
import ChatIcon from "./Components/ChatIcon.jsx";

// ScrollToTop component to ensure pages start at the top
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [isLoading, setIsLoading] = useState(true);

  // This will change isLoading to false after the loading screen duration
  const handleLoadingComplete = () => {
    setIsLoading(false);
  };

  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <div>
        {isLoading ? (
          <LoadingScreen onLoadingComplete={handleLoadingComplete} />
        ) : (
          <>
            <ScrollToTop />
            <Nav />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/gallery" element={<CompletedProject />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/services" element={<Services />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/service/:id" element={<ServiceDetail />} />
            </Routes>
            <Footer />
            <ChatIcon />
            <WhatsAppButton />
          
          </>
        )}
      </div>
    </Router>
  );
}

export default App;

